import request from "@/axios";
// 查询榜单内容管理列表（线上）
export const getStrategyList = (params) => {
  return request({
    url: '/lebo-card/appCardStrategy/page',
    method: 'get',
    params
  })
}

// 删除列表
export const deleteAppCard = (params) => {
  return request({
    url: "/lebo-card/appCardStrategy/local/remove",
    method: "post",
    params
  });
}

// 日志接口
export const getLogList = (params) => {
  return request({
    url: "/lebo-card/web/card/operation-log/page",
    method: "get",
    params: {
      ...params,
      module: 1
    }
  });
}

/** 获取本地数据列表 */
export const getStrategyLocalList = (params) => {
  return request({
    url: "/lebo-card/appCardStrategy/local/page",
    method: "get",
    params,
  });
};

/** 提交审核 */
export const submitAudit = (id) => {
  return request({
    url: `/lebo-card/appCardStrategy/local/batch-submit`,
    method: "post",
    params: {
      ids: id
    }
  });
};

/** 撤销审核 */
export const cancelAudit = (id) => {
  return request({
    url: `/lebo-card/appCardStrategy/local/batch-withdraw`,
    method: "post",
    params: {
      ids: id
    }
  });
};

/** 命中查询app卡片 */
export const hitQueryCard = (appId, params) => {
  return request({
    url: '/lebo-card/app-card/list',
    method: 'get',
    headers: {
      'App-Id': appId
    },
    params
  });
};

/** 命中查询app置顶卡片 */
export const hitQueryTopCard = (appId, params) => {
  return request({
    url: '/lebo-card/app-card/list/top',
    method: 'get',
    headers: {
      'App-Id': appId
    },
    params
  });
};

/** 命中查询app非置顶卡片 */
export const hitQueryNotTopCard = (appId, params) => {
  return request({
    url: '/lebo-card/app-card/page',
    method: 'get',
    headers: {
      'App-Id': appId
    },
    params
  });
};

/** 命中查询匹配App投屏功能配置 */
export const hitQueryAppScreenConfig = (appId, params) => {
  return request({
    url: '/lebo-card/app-card/screen-cast-config',
    method: 'get',
    headers: {
      'App-Id': appId
    },
    params
  });
};

